import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  Pipe,
  PipeTransform,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  HostListener,
  OnChanges,
  OnDestroy
} from '@angular/core';
import { FormBuilder, FormGroup, Form, ReactiveFormsModule } from '@angular/forms';
import {Observable, Subject} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { AutocompleteserversideService } from './autocomplete-serverside.service';
import * as myGlobals from '../../../shared/globalcontants'; // CONSTANT FILE ADD ANY CONSTANT VALUE
import { CommonService } from '../../services/common.service';
import { CSharpRequestService } from 'src/app/shared/services/csharp-request.service';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime } from 'rxjs/operators';
import { ISubscription } from 'rxjs/Subscription';
import { MatFormField, MatInput } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from '../../popup/popup.component';

@Component({
    selector: 'app-autocomplete-serverside',
    templateUrl: './autocomplete-serverside.component.html',
    styleUrls: ['./autocomplete-serverside.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ReactiveFormsModule, MatFormField, MatInput, NgClass]
})
@HostListener('window:resize', ['$event'])
export class ServersideutoCompleteComponent implements OnInit, OnChanges, OnDestroy {
    public searchForm: FormGroup;
    public searchDropdown: Array<any>;
    public optionArray: Array<any>;
    public optionsArray: Array<any>;
    public isDataLoaded: any;
    public searchTableData: Array<any> = [];
    public showRecents = false;
    public storageKey: any;
    public setDataToTable: any;
    public globalConst: any;
    public scanned = false;
    closeIcon = false;
    @ViewChild('inputValue') inputValue: ElementRef;
    @Output() messageEvent = new EventEmitter<any>();
    @Output() optionSelect = new EventEmitter<any>();
    @Output() callFocusOut = new EventEmitter<any>();
    @Output() callFocusIn = new EventEmitter<any>();
    @Output() pasteFunc = new EventEmitter<any>();
    @Input() dataCollection: any;
  @Input() searchoptionalParams: any;
  @Input() ModuleName: string;
  @Input() componentNameRef: string;
  @Input() functionName: string;
  searchType: any;
  debounceSub = new Subject();
  debounceSubscription: ISubscription;
  selectedValue = true;
  hideBarCode: any = ['Inventory'];
  sourceName: any;
  keypresscount = 0;
  keylength = 0;
  constructor(private csharpService: CSharpRequestService,
     private fb: FormBuilder, public _as: AutocompleteserversideService, public _commonService: CommonService,
    private _ts: TranslateService, private dialog: MatDialog) {

    const waitTime: number = this._commonService && this._commonService.debounceTime ? this._commonService.debounceTime : 500;
    this.debounceSubscription = this.debounceSub.pipe(debounceTime(waitTime)).subscribe((data) => {
      // this.filterData(data);
      this.pasteFunc.emit(data);
    });


  }

   /**
   * @function filterData(e)
   * @Input params None
   * @description clear the previous array value instance
   * output Array
   */

   filterData(event) {
    this.keypresscount = this.keypresscount + 1;
     // alert(event.keyCode+":"+event.code+":"+event.key+":"+event.type+":"+event.which);
     this.closeIcon = true;
     const filterInputvalue = this.inputValue.nativeElement.value;

     if (this.keylength > filterInputvalue.length) {

     } else {

      this.keylength = filterInputvalue.length;
      if (filterInputvalue.length > this.keypresscount) {
      } else {
        this.keypresscount = 0;
      }
     }
     if (filterInputvalue.length > 2 && this.keypresscount === 1) {
      if(filterInputvalue.trim() !== '') {
      this._commonService.isBarcodeScan = true;
      this.inputValue.nativeElement.blur();
      this.scanned = true;
      this.debounceSub.next(filterInputvalue);
      this.keypresscount = 0;


      this.keylength = 0;
      } else {
        this.showNoDataFoundPopUp();
      }
     } else {

       if (filterInputvalue.length > 0) {
        this.keypresscount = this.keypresscount + 1;
       } else {
         this.keypresscount = 0;
       }

      // alert("Else filterInputValue "+filterInputvalue);
      (filterInputvalue.toString() === '') ? this.closeIcon = false : this.closeIcon = true;
      // if( filterInputvalue.toString().trim().toLowerCase().length >= Number(this._commonService.searchChar) )
      // this.messageEvent.emit(filterInputvalue);
        this.messageEvent.emit(filterInputvalue);
        // this.keylength=0;
     }

    return;
  }

  showNoDataFoundPopUp() {
    const dialogArray = {
      headerText: this._ts.instant('common.error'),
      contentText: this._ts.instant('common.noDataFound'),
      cancelText: false,
      confirmText: 'ok'
    };
    this._commonService.mobilePopUpProperty.data = dialogArray;
    this.dialog.open(PopupComponent, this._commonService.mobilePopUpProperty);
  }

  /**
   * @function clearInput()
   * @Input params None
   * @description clear the previous array value instance
   * output Array
   */
  clearInput(event) {
    this.keylength = 0;
    this.keypresscount = 0;
    this.inputValue.nativeElement.value = '';
    const filterInputvalue = this.inputValue.nativeElement.value;
    this.closeIcon = this.inputValue.nativeElement.value ? true : false;
    console.log('Model input value', this.searchForm.controls.searchText.value);
    const inputData = this.inputValue.nativeElement.value;
    this.messageEvent.emit(inputData);
  }
  assignTextValueFromReader(searchValue) {
    this.searchForm.controls.searchText.setValue(searchValue);
  }
  clearData = () => {
    this.keylength = 0;
    this.keypresscount = 0;
    this.inputValue.nativeElement.value = '';
    if (this.scanned) {
     this.inputValue.nativeElement.focus();
    }

    this.searchForm.controls.searchText.setValue('');
    const filterInputvalue = this.inputValue.nativeElement.value;
    this.closeIcon = false;
    this.scanned = false;
    console.log(filterInputvalue);
    this.messageEvent.emit(filterInputvalue);
  }
  ngOnInit() {

    /**
     * @description create the form group
     */
    this.searchForm = this.fb.group({
        searchText: '',
        searchReq: '',
        typeSelected: ''
      });

      /**
       * @description Default serach dropdown array  bind the DOM
       */
      this.searchDropdown = [
        { id: 1, viewValue: 'Inventory' },
        { id: 2, viewValue: 'Package' },
        { id: 3, viewValue: 'Recipe' }
      ];

      /**
       * Get Global Constant Value
       */
      this.globalConst = myGlobals.NUMBER_VALUES;
      this.searchType = this.searchoptionalParams.searchType;
}

  getBarcode(componentRef, funcName) {
    this.csharpService.GetBarcode(componentRef, funcName);
  }

dropdownChanged(data) {
  this.selectedValue = this.hideBarCode.some(value => value.toLowerCase() === data.toLowerCase());
  this._commonService.selectedDropDown = data;
  this.optionSelect.emit(data);
}

ngOnChanges() {
  if (this.dataCollection.searchSources) {
  this.dataCollection.searchSources.forEach(element => {
    const name = 'common.' + element?.SourceName;
    element.newSourceName = this._ts.instant(name);
  });
  }
  if (this._commonService.selectedDropDown) {
    this.dataCollection.defaultItem = this._commonService.selectedDropDown;
    this.optionSelect.emit(this.dataCollection.defaultItem );
    this.selectedValue = this.hideBarCode.some(value => value.toLowerCase() === this._commonService.selectedDropDown.toLowerCase());
  }
  this.sourceName = this.dataCollection.searchSources ? this.dataCollection.searchSources.filter(
    x => x.SourceId === 102)[0]?.SourceName : '';
}

callFO() {
  this.clearData();
  this.callFocusOut.emit();
}
callFI() {
  this.callFocusIn.emit();
}

pasted(event) {
  if ( this.sourceName === this._commonService.selectedDropDown) {
    console.log('pasted');
    const pastedData = event.clipboardData.getData('text');
    console.log(pastedData);
   this.pasteFunc.emit(pastedData);
  }
  }

  onSearchChange(searchValue: string): void {
    if (searchValue.length > 2) {
      this.debounceSub.next('event');
    }
  }
  ngOnDestroy() {
    this.searchForm.controls.searchText.setValue('');
    this.searchForm.updateValueAndValidity();
    if (this.debounceSubscription) {
      this.debounceSubscription.unsubscribe();
    }
  }
}
